import React from 'react';

import classNames from 'classnames';

import InBetweenSwitch from '@components/common/InBetweenSwitch/InBetweenSwitch';

import ClearButton from './ClearButton';
import css from './filters.module.sass';

const Toggle = ({ value, onFilter, alias = 'active', label = 'Active', ...props }) => {
  const isValueSet = value != null;
  return (
    <InBetweenSwitch
      className={classNames(css.withMaterialBorder, isValueSet ? css.active : '', props.className)}
      value={value}
      appendix={isValueSet && <ClearButton onClick={() => onFilter(alias, null)} />}
      label={label}
      onChange={({ target: { checked } }) => onFilter(alias, Number(checked))}
    />
  );
};
export default Toggle;
